"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateNameCharacters = void 0;
function validateNameCharacters(name) {
    return /^([a-zA-ZáéíóúâêîôûãõàäëïöüÁÉÍÓÚÂÊÎÌÒÙÈÔÛÀÃÕÄËÏÖÜçÇ\sèñÈÑ-]+)+$/.test(name);
}
exports.validateNameCharacters = validateNameCharacters;
//# sourceMappingURL=validateNameCharacters.js.map